import React, { useCallback } from 'react';
import ModalEdgeCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalEdgeCloseBtn';
import ModalGroupBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalGroupBtn';
import ModalCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalCloseBtn';
import ModalTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ModalTitle';
import * as S from './style';

interface IProps {
  onSubmit?: () => void;
  onClose?: () => void;
  value: { isDesktop: boolean; isIPhoneXApp: boolean };
}

const AgreeModal = ({ onSubmit, onClose, value }: IProps) => {
  const { isDesktop, isIPhoneXApp } = value;

  const handleSubmit = useCallback(() => {
    if (typeof onSubmit === 'function') onSubmit();
  }, [onSubmit]);

  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  return (
    <S.AgreeModal>
      {isDesktop ? (
        <ModalCloseBtn onClick={handleClose} />
      ) : (
        <ModalEdgeCloseBtn onClick={handleClose} />
      )}
      <ModalTitle title="개인정보의 수집 및 이용안내(필수)" />
      <div className="content">
        <div className="agree-ctns">
          <table>
            <thead>
              <tr>
                <th>구분</th>
                <th>수집항목</th>
                <th>이용목적</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>기타 서비스</td>
                <td>휴대폰 번호</td>
                <td>라이브 알림 발송</td>
              </tr>
            </tbody>
          </table>
          <ul className="unorder-list">
            <li>
              개인정보의 보유 및 이용 기한
              <br />
              <em>회원탈퇴 시 또는 법정 의무 보유기간</em>
            </li>
            <li>
              이용자는 동의를 거부할 권리가 있습니다. 단, 동의를 거부할 경우
              서비스 이용이 불가합니다.
            </li>
          </ul>
        </div>
      </div>
      <ModalGroupBtn
        secondaryBtn={{ text: '취소', onClick: handleClose }}
        primaryBtn={{
          text: '동의하기',
          onClick: handleSubmit,
        }}
      />
    </S.AgreeModal>
  );
};

export default AgreeModal;
